(function () {
  'use strict';

  function init() {
    var toc = document.querySelector('.ln-ae__toc[data-article-toc]');
    if (!toc || toc.hidden || toc.dataset.lnCompactReady === 'true') return;
    toc.dataset.lnCompactReady = 'true';

    var list = toc.querySelector('ol');
    if (!list || !list.children.length) return;

    var labelNode = toc.querySelector('p');
    var details = document.createElement('details');
    details.className = 'ln-ae__toc-details';

    var summary = document.createElement('summary');
    var label = document.createElement('span');
    label.textContent = labelNode ? labelNode.textContent : 'I denne guide';
    var plus = document.createElement('span');
    plus.setAttribute('aria-hidden', 'true');
    plus.textContent = '+';
    summary.appendChild(label);
    summary.appendChild(plus);

    var panel = document.createElement('div');
    panel.className = 'ln-ae__toc-panel';
    panel.appendChild(list);
    details.appendChild(summary);
    details.appendChild(panel);
    toc.replaceWith(details);

    details.addEventListener('toggle', function () {
      if (!details.open) return;
      document.dispatchEvent(new CustomEvent('ln:event', { detail: { event: 'article_toc_open' } }));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
